import React from 'react';
import Container from './Container';
import Row from './Row';

export default ({ distance, address }) => (
  <Container>
    <div>{distance}</div>
    <Row>
      {address.address1}
      {address.address2 && `, ${address.address2}`}
    </Row>
    <Row>
      {address.city} {address.state}, {address.zip}
    </Row>
  </Container>
);
